
import { Search, Target, Award } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VaeFeaturesSection = () => {
  const { t } = useTranslation('individuals');

  const features = [
    {
      icon: <Search className="w-6 h-6 text-brand-orange" />,
      title: t('vae.features.search.title'),
      description: t('vae.features.search.description')
    },
    {
      icon: <Target className="w-6 h-6 text-brand-orange" />,
      title: t('vae.features.identify.title'),
      description: t('vae.features.identify.description')
    },
    {
      icon: <Award className="w-6 h-6 text-brand-orange" />,
      title: t('vae.features.track.title'),
      description: t('vae.features.track.description')
    }
  ];

  return (
    <section className="py-24 bg-card">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="grid sm:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="group bg-background rounded-xl p-8 hover:shadow-xl transition-all duration-300 border border-border hover:-translate-y-1"
              >
                <div className="flex items-center justify-center mb-6">
                  <div className="p-3 bg-brand-orange/10 dark:bg-brand-orange/5 rounded-xl group-hover:scale-110 transition-transform">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="text-xl font-medium text-brand-blue dark:text-brand-orange mb-4 text-center group-hover:text-[#8B5CF6] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-center leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="/search"
              className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
            >
              {t('vae.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VaeFeaturesSection;
